import { CSSProperties } from "react";
import InputMask from "react-input-mask";
import RxTextField from "../RxTextField";

interface RxMaskedTextFieldProps {
	fullwidth?: boolean;
	id?: string;
	name?: string;
	label?: string;
	placeholder?: string;
	value?: string | number;
	required?: boolean;
	style?: CSSProperties;
	onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
	onBlur?: any;
	variant?: "standard" | "filled" | "outlined";
	size?: "small" | "medium";
	mask: string | (string | RegExp)[];
	alwaysShowMask?: boolean;
	inputStyle?: CSSProperties;
	inputClassName?: string;
	helperText?: string | false;
	error?: boolean;
}

const RxMaskedTextField = (props: RxMaskedTextFieldProps) => {
	return (
		<InputMask
			id={props.id}
			name={props.name}
			value={props.value}
			onChange={props.onChange}
			onBlur={props.onBlur}
			mask={props.mask}
			alwaysShowMask={props.alwaysShowMask}
		>
			<RxTextField
				fullwidth={props.fullwidth}
				required={props.required}
				label={props.label}
				placeholder={props.placeholder}
				style={props.style}
				variant={props.variant}
				size={props.size}
				inputStyle={props.inputStyle}
				inputClassName={props.inputClassName}
				error={props.error}
				helperText={props.helperText}
			/>
		</InputMask>
	);
};

export default RxMaskedTextField;
